import { dom, library } from '@fortawesome/fontawesome-svg-core';
import { html, css, LitElement, nothing } from 'lit';
import { customElement, property, state } from 'lit/decorators.js';
import { svgWithJs, variables } from '../variables';

import '../icons/icon/apt-icon'
import { faLockOpen, faLock } from '@fortawesome/pro-solid-svg-icons';

@customElement('apt-lock-allocation')
export class AptLockAllocation extends LitElement {


  @state() lockOpenIcon = {
    class: 'fa-solid fa-lock-open',
    name: faLockOpen,
    color: ''
  };

  @state() lockIcon = {
    class: 'fa-solid fa-lock',
    name: faLock,
    color: ''
  };

  defaultIconProperties = {
    width: '14px',
    height: '14px',
    padding: '0',
    iconSize: '14px',
    textSize: '14px',
    iconTextBottom: '14px',
    color: 'gray-400',
    bgColor: 'transparent',
    hoverColor: 'gray-700',
    hoverBgColor: 'transparent',
    disabledColor: 'gray-400',
    disabledBgColor: 'transparent',
  };

  @property({ type: Boolean }) disabled = false;
  @property({ type: Boolean }) locked = false;
  static override get styles() {
    return [
      variables,
      svgWithJs,
      css`
        :host {
          font-size: small;
          color: var(--gray-800);
          min-width: auto;
          max-width: fit-content;
          display: flex;
          flex-direction: column;
          background-color: transparent;
          user-select: none;
          cursor: pointer;
        }

        .icon {
          display: flex;
          min-height: 12px;
          width: 14px;
          align-items: center;
          font-weight: 400;
        }

       
      `,
    ];
  }

  getIconProperties() {
    return {
      ...this.defaultIconProperties,
      color: this.defaultIconProperties.color as string,
      hoverColor: this.defaultIconProperties.hoverColor as string,
    };
  }

  getIcon() {
    if (this.locked) {
      return html`
      <apt-icon
          .data="${{
          type: this.lockIcon.name,
          text: '',
          class: this.lockIcon.class
        }
        }"
          .properties = "${this.getIconProperties()}"  
          ?disabled = "${this.disabled}">
          <span></span>
          </apt-icon>`
    } else {
      return html`
      <apt-icon
                  .data="${{
          type: this.lockOpenIcon.name,
          text: '',
          class: this.lockOpenIcon.class
        }
        }"
          .properties = "${this.getIconProperties()}"  
          ?disabled = "${this.disabled}">
                  <span></span>
                  </apt-icon>`
    }

  }

  override render() {
    return html`
      <div class='icon' @click="${this.toggle}">
          ${this.getIcon()}
    </div>
    `;
  }

  toggle() {
    if (!this.disabled) {
      this.setStatus();
      this.requestUpdate();
      this.dispatchEvent(new window.CustomEvent('checked', { composed: true, bubbles: true, detail: this.locked }));
    }
  }

  setStatus() {
    this.locked = !this.locked;
  }

  protected override firstUpdated(): void {

    library.add(faLock, faLockOpen);

    // @ts-ignore The dom.watch() TS definition indicates no parameters for this. However, when
    // you actually dig into the code, you see that it looks at the arguments after it gets into
    // the code and tries to pull some out if there aren't any (it even supplies an empty object
    // for options if you don't supply one yourself).
    //
    // Note: We have to wait for the first update for the shadow DOM to even be created.
    dom.watch({
      autoReplaceSvgRoot: this.shadowRoot,
      observeMutationsRoot: this.shadowRoot,
    });
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'apt-lock-allocation': AptLockAllocation;
  }
}
